import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  tableWrapper: {
    maxHeight: 420,
    overflow: 'auto',
    margin: '12px 0 0'
  },
  // Cells default to `align-items: stretch` (the grid default) so every cell
  // in a row shares the same box height — a border-top on one cell then lands
  // at the same y as a border-top on its neighbour, even when one is empty
  // (e.g. spacerCell) and the other has padding/content (e.g. attributeNameCell).
  // Content is centred inside each cell's own flex box instead.
  grid: {
    display: 'grid',
    rowGap: 4
  },
  headerCell: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 8px',
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    zIndex: 1
  },
  attributeNameCell: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 8px 4px',
    borderTop: '1px solid #e0e0e0'
  },
  spacerCell: {
    borderTop: '1px solid #e0e0e0'
  },
  valueCell: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px 4px 20px'
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export default useStyles
